import { z } from 'zod';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { EnumSchema, Executor, FromSchema, ZodDate } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { InsuranceProvider, InsuranceStatus } from '../insurance';

export const InsuranceCoverSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        provider: z.string(),
        status: EnumSchema(InsuranceStatus),
        grade: z.string().optional(),
        amount: z.number().optional(),
        currency: EnumSchema(Currency),
        decisionDate: ZodDate.optional(),
        startDate: ZodDate.optional(),
        expireDate: ZodDate.optional(),
        decisionNote: z.string().optional(),
        companyIdentifier: z.string().optional(),
    }),
).strict();

export class InsuranceCover extends FromSchema(InsuranceCoverSchema) implements BaseEntity {
    id: string;
    buyer: string;
    provider: InsuranceProvider | string;

    status: InsuranceStatus;
    grade?: string;
    amount?: number;
    currency?: Currency;
    decisionDate?: Date;
    startDate?: Date;
    expireDate?: Date;
    decisionNote?: string;
    companyIdentifier?: string;

    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
